import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const Checkbox = (props) => <Component {...transform(props)} />;

export default Checkbox;

export { Component as component, fixtures, transform as transformer };
